import React from "react";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {
  Paper,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { InputAdornment } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import Fab from "@material-ui/core/Fab";
import PaymentOutlined from "@material-ui/icons/PaymentOutlined";
import moment from "moment";
import { withRouter } from "react-router";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReactTooltip from "react-tooltip";
import { findDOMNode } from "react-dom";
import { Api } from "../../utils/api";
import { Invoicexpress } from "../../utils/invoicexpress";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";

class paymentsGridComponent extends React.Component {
  state = {
    showModal: false,
    errors: {},
    newPaymentItem: {},
    payments: [],
    easypay_payment_id: null,
  };

  constructor() {
    super();
    this.api = new Api();
    this.iexpress = new Invoicexpress();
    this.goTo = this.goTo.bind(this);
  }

  componentDidMount() {
    this.setState({ easypay_payment_id: this.props.easypay_payment_id });
    this.setState({ payments: this.props.payments }); //set next payments as an array
  }

  /**
   *
   */

  editPayment(payment) {
    this.setState({ showModal: true, newPaymentItem: payment });
  }

  deletePayment(payment) {
    let paymentToDelete = payment;
    paymentToDelete = { ...paymentToDelete, toDelete: true };
    this.addOrReplacePayment(paymentToDelete);
  }

  addOrReplacePayment(paymentToAdd) {
    const payments = this.state.payments;
    const paymentAlreadyExists =
      payments.findIndex((el) => {
        return el.ep_key === paymentToAdd.ep_key;
      }) !== -1;
    if (!paymentAlreadyExists)
      payments.push({ toAdd: true, edited: true, ...paymentToAdd });
    else {
      payments.splice(
        payments.findIndex((el) => {
          return el.ep_key === paymentToAdd.ep_key;
        }),
        1
      );
      payments.push({ edited: true, ...paymentToAdd });
    }
    this.setState({ payments });
  }

  /**
   *
   */

  validateFormField = (e) => {
    const propName = e.target.id;
    const value = e.target.value;
    const errors = { ...this.state.errors };
    const newPaymentItem = { ...this.state.newPaymentItem };
    //errors
    errors[propName] = "";
    if (value === "") errors[propName] = "Campo obrigatório!";
    this.setState({ errors });
    //new payment item
    newPaymentItem["ep_key"] =
      this.state.newPaymentItem.ep_key || new Date().getTime();
    newPaymentItem[propName] = value;
    this.setState({ newPaymentItem });
    //console.log(newPaymentItem);
  };

  markAsRecurrent = (e) => {
    const checked = e.target.checked;
    const newPaymentItem = { ...this.state.newPaymentItem };
    newPaymentItem.ep_payment_type = checked ? "RP" : null;
    this.setState({ newPaymentItem });
  };

  /**
   *
   */

  handleClose = (event) => {
    this.setState({ showModal: false });
  };

  handleSave = (event) => {
    if (
      (this.state.errors.ep_value && this.state.errors.ep_value !== "") ||
      (this.state.errors.description && this.state.errors.description !== "") ||
      (this.state.errors.payment_at && this.state.errors.payment_at !== "")
    )
      return;
    //
    const newPayment = this.state.newPaymentItem;
    newPayment.payment_at = moment(newPayment.payment_at).utc(true);
    this.addOrReplacePayment(newPayment);
    //
    this.setState({ showModal: false });
    //
    this.handleClose();
  };

  handleShow() {
    this.setState({
      newPaymentItem: {
        payment_at: moment(new Date()).format("YYYY-MM-DD"),
        edited: true,
      },
    });
    this.setState({ showModal: true });
  }

  goTo(location, params) {
    this.props.history.push(location, params);
  }

  getRowColor(payment) {
    if (payment.toDelete) return "red";
    if (!this.props.canAdd || payment.edited) return "#A9A9A9";
    return "";
  }

  /**
   *
   */

  render() {
    const { payments } = this.props;

    return payments ? (
      this.renderGrid()
    ) : (
      <div>
        <CircularProgress color="primary" />
      </div>
    );
  }

  renderGrid() {
    //

    const gridTitle = this.props.title;
    const canAdd = this.props.canAdd;
    const canEdit = this.props.canEdit;
    const canEditAmount =
      this.props.canEditAmount !== undefined ? this.props.canEditAmount : false;
    const showDate =
      this.props.showDate !== undefined ? this.props.showDate : true;
    const canDelete = this.props.canDelete;
    const showInvoices = this.props.showInvoices;
    const payments = this.state.payments;
    console.log(this.state.newPaymentItem);
    //
    return (
      <>
        <Grid container alignItems="center">
          <Typography variant="h6" color="#505e6b" gutterBottom>
            {gridTitle}
          </Typography>
          {canAdd && (
            <Fab
              style={{ marginLeft: "20px" }}
              size="small"
              color="primary"
              aria-label="Add"
              onClick={() => this.handleShow()}
            >
              <AddIcon />
            </Fab>
          )}
        </Grid>

        <Grid item md={12} style={{ marginTop: "20px" }}>
          <Grid
            container
            alignItems="center"
            className={`valence-card-padding`}
          >
            {showDate && (
              <Grid item md={1}>
                Data
              </Grid>
            )}
            <Grid item md={2}>
              Descrição
            </Grid>
            <Grid item md={4}>
              Observações
            </Grid>
            <Grid item md={1} style={{ textAlign: "right" }}>
              Montante
            </Grid>
            <Grid item md={1} style={{ textAlign: "right" }}>
              Status
            </Grid>
            <Grid item md={1} style={{ textAlign: "right" }}>
              {canEdit && "Editar"}
            </Grid>
            <Grid item md={1} style={{ textAlign: "right" }}>
              {canDelete && "Eliminar"}
            </Grid>
          </Grid>

          <Paper elevation={1} square className="distance-from-top">
            {payments.map((payment, idx) => (
              <Grid
                container
                alignItems="center"
                className={`valence-card-padding`}
                style={
                  idx % 2
                    ? { background: "lightgray" }
                    : { background: "white" }
                }
              >
                {showDate && (
                  <Grid item md={1}>
                    <Typography
                      style={{ color: this.getRowColor(payment) }}
                      variant="body2"
                    >
                      {moment(
                        payment.payment_at ? payment.payment_at : new Date()
                      ).format("YYYY-MM-DD")}
                    </Typography>
                  </Grid>
                )}
                <Grid
                  item
                  md={2}
                  style={{
                    textAlign: "left",
                    color: this.getRowColor(payment),
                  }}
                >
                  {payment.description}
                </Grid>
                <Grid
                  item
                  md={4}
                  style={{
                    textAlign: "left",
                    whiteSpace: "pre-line",
                    color: this.getRowColor(payment),
                  }}
                >
                  {payment.observations}
                </Grid>
                <Grid item md={1}>
                  <Typography
                    style={{
                      textAlign: "right",
                      color: this.getRowColor(payment),
                    }}
                    variant="body2"
                  >
                    <FontAwesomeIcon icon="euro-sign" />
                    {payment.ep_value}
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={1}
                  style={{
                    textAlign: "right",
                    whiteSpace: "pre-line",
                    color: this.getRowColor(payment),
                  }}
                >
                  {payment.ep_status}
                </Grid>
                {canEdit && (
                  <Grid item md={1} style={{ textAlign: "right" }}>
                    <Tooltip title="Editar cobrança">
                      <Button
                        onClick={() => this.editPayment(payment)}
                        color="primary"
                        onMouseOver={() =>
                          ReactTooltip.show(
                            findDOMNode(
                              this.refs["edit_tooltip_" + payment.ep_key]
                            )
                          )
                        }
                        onMouseLeave={() =>
                          ReactTooltip.hide(
                            findDOMNode(
                              this.refs["edit_tooltip_" + payment.ep_key]
                            )
                          )
                        }
                      >
                        <EditIcon />
                        {/* <p ref={'edit_tooltip_'+payment.ep_key} data-tip='Editar cobrança' style={{textTransform:"none"}}></p> */}
                        <ReactTooltip className="payments-tooltip" />
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                {canDelete && (
                  <Grid item md={1} style={{ textAlign: "right" }}>
                    <Tooltip title="Eliminar cobrança">
                      <Button
                        onClick={() => this.deletePayment(payment)}
                        color="primary"
                        onMouseOver={() =>
                          ReactTooltip.show(
                            findDOMNode(
                              this.refs["delete_tooltip_" + payment.ep_key]
                            )
                          )
                        }
                        onMouseLeave={() =>
                          ReactTooltip.hide(
                            findDOMNode(
                              this.refs["delete_tooltip_" + payment.ep_key]
                            )
                          )
                        }
                      >
                        <DeleteIcon />
                        {/* <p ref={'edit_tooltip_'+payment.ep_key} data-tip='Eliminar cobrança' style={{textTransform:"none"}}></p> */}
                        <ReactTooltip className="payments-tooltip" />
                      </Button>
                    </Tooltip>
                  </Grid>
                )}
                {payment.easypay_reference_id &&
                  showInvoices &&
                  !payment.invoice_id && (
                    <>
                      <Tooltip title="Criar fatura">
                        <Button
                          aria-label="Invoice"
                          onClick={() =>
                            this.goTo(`/invoices/${payment.ep_key}`)
                          }
                          onMouseOver={() =>
                            ReactTooltip.show(
                              findDOMNode(
                                this.refs["invoice_tooltip_" + payment.ep_key]
                              )
                            )
                          }
                          onMouseLeave={() =>
                            ReactTooltip.hide(
                              findDOMNode(
                                this.refs["invoice_tooltip_" + payment.ep_key]
                              )
                            )
                          }
                        >
                          <Fab
                            size="small"
                            color="secondary"
                            aria-label="Invoice"
                          >
                            <PaymentOutlined />
                          </Fab>
                          {/* <p ref={'invoice_tooltip_'+payment.ep_key} data-tip='Criar fatura' style={{textTransform:"none"}}></p> */}
                          <ReactTooltip className="payments-tooltip" />
                        </Button>
                      </Tooltip>
                    </>
                  )}
                {payment.invoice_id && showInvoices && (
                  <>
                    <Tooltip title="Ver fatura">
                      <Button
                        aria-label="Invoice"
                        onClick={() =>
                          this.iexpress.openInvoice(payment.invoice_id)
                        }
                        onMouseOver={() =>
                          ReactTooltip.show(
                            findDOMNode(
                              this.refs["invoice_tooltip_" + payment.ep_key]
                            )
                          )
                        }
                        onMouseLeave={() =>
                          ReactTooltip.hide(
                            findDOMNode(
                              this.refs["invoice_tooltip_" + payment.ep_key]
                            )
                          )
                        }
                      >
                        <a>{payment.invoice_sequence_nr}</a>
                        {/* <p ref={'invoice_tooltip_'+payment.ep_key} data-tip='Ver fatura' style={{textTransform:"none"}}></p> */}
                        <ReactTooltip className="payments-tooltip" />
                      </Button>
                    </Tooltip>
                  </>
                )}
              </Grid>
            ))}
          </Paper>
        </Grid>

        <Dialog
          open={this.state.showModal}
          onClose={this.handleClose}
          onExit={this.handleExit}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Cobrança</DialogTitle>
          <DialogContent>
            <DialogContentText>Preencha os dados cobrança</DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="description"
              label="Descrição"
              type="text"
              variant="outlined"
              fullWidth
              value={this.state.newPaymentItem.description}
              onChange={this.validateFormField}
              onSelect={this.validateFormField}
              disabled={false}
              required={true}
              error={this.state.errors.description}
            />
            <TextField
              autoFocus
              margin="dense"
              id="observations"
              label="Observações"
              type="text"
              variant="outlined"
              fullWidth
              value={this.state.newPaymentItem.observations}
              onChange={this.validateFormField}
              onSelect={this.validateFormField}
              disabled={false}
            />
            <TextField
              autoFocus
              margin="dense"
              id="ep_value"
              label="Valor"
              type="number"
              variant="outlined"
              fullWidth
              value={this.state.newPaymentItem.ep_value}
              required={true}
              error={this.state.errors.ep_value}
              onChange={this.validateFormField}
              onSelect={this.validateFormField}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">€</InputAdornment>
                ),
              }}
              disabled={!canEditAmount}
            />
            {showDate && (
              <TextField
                autoFocus
                margin="dense"
                id="payment_at"
                type="date"
                label="Data"
                variant="outlined"
                fullWidth
                value={moment(
                  this.state.newPaymentItem.payment_at
                    ? this.state.newPaymentItem.payment_at
                    : new Date()
                ).format("YYYY-MM-DD")}
                required={true}
                onChange={this.validateFormField}
                onSelect={this.validateFormField}
                error={this.state.errors.payment_at}
              />
            )}
            <TextField
              autoFocus
              margin="dense"
              id="invoice_id"
              label="ID Fatura InvoiceXpress"
              type="text"
              variant="outlined"
              fullWidth
              value={this.state.newPaymentItem.invoice_id}
              onChange={this.validateFormField}
              onSelect={this.validateFormField}
              disabled={false}
            />
            {!this.state.newPaymentItem.ep_payment_type && (
              <TextField
                autoFocus
                margin="dense"
                id="establishments_request_id"
                label="ID Pedido de encaminhamento"
                type="number"
                variant="outlined"
                fullWidth
                value={this.state.newPaymentItem.establishments_request_id}
                onChange={this.validateFormField}
                onSelect={this.validateFormField}
                disabled={this.state.newPaymentItem.ep_payment_type}
              />
            )}
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.newPaymentItem.ep_payment_type === "RP"}
                  onChange={this.markAsRecurrent}
                  name="ep_payment_type"
                  color="primary"
                />
              }
              label="Pagamento recorrente?"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSave} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default withRouter(paymentsGridComponent);
